import { RECAPTCHA_LOADER_OPTIONS } from 'ng-recaptcha-2';

export const recaptchaProvider = {
  provide: RECAPTCHA_LOADER_OPTIONS,
  useValue: {
    onBeforeLoad(url: any) {
      url.searchParams.set('hl', 'fa');
      return { url };
    },
  },
};
